import omit from 'lodash/omit';

import { enabledDishes as nyEnabledDishes } from './ny';


export const periods = [
    '2025-12-29', '2025-12-30',
    '2026-01-05', '2026-01-06',
];

const enabledDishes = omit(nyEnabledDishes, 'set', 'gifts');

export const dishes = [...new Set(Object.values(enabledDishes).flat())];

